/**
 * A tela fica em `components/dev/` (par `.tsx` nativo + `.web.tsx`) porque o
 * contexto de rotas do expo-router não filtra `.native.tsx` por plataforma: a
 * rota nativa entrava no bundle web e quebrava ao importar
 * `@stripe/stripe-react-native`.
 */
export { ConnectSpikeScreen as default } from '@/components/dev/connect-spike-screen';
